import React, { useEffect, useState } from 'react';
import get from 'lodash.get';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { APP_LABELS } from '@config/app-config';

import CustomModal from '@utilities/CustomModal';

import { DashboardOverviewSelector } from '@redux/annualReport-overview/selectors';
import { GetBrachYearWiseReportSelector } from '@redux/overnight-camp-data-overview/selectors';
import { OvernightCampBranchDetailsDashboardSelector } from '@redux/overnight-camp-data-report-dashboard/selectors';

import tabCheck from '@static/images/annualReports/tabCheck.svg';
import tabDesign from '@static/images/annualReports/tabDesign.svg';
import tabComponent from '@static/images/annualReports/tabComponent.svg';

const SidebarNav = props => {
  const {
    setActiveTab,
    setIsDataLoading,
    CampReportsYearData,
    allCampBranchDashboardData
  } = props;

  const [showPopup, setShowPopup] = useState(false);
  const [menuItems, setMenuItems] = useState(null);

  const handleSetActive = value => {
    sessionStorage.setItem('active', value);
    if (
      value !== sessionStorage.getItem('lastactivetab') &&
      sessionStorage.getItem('dirty') === 'true'
    ) {
      setShowPopup(true);
    } else {
      setActiveTab(value);
    }
  };

  const handleOk = () => {
    setActiveTab(sessionStorage.getItem('active'));
    setShowPopup(false);
  };

  const handleCancel = () => {
    const activetab = sessionStorage.getItem('lastactivetab');
    document.getElementById(activetab).click();
    setActiveTab(activetab);
    setShowPopup(false);
  };

  const navbarListIds = [
    {
      id: 'v-pills-Staff-tab',
      target: '#v-pills-Staff'
    },
    {
      id: 'v-pills-participationsAndEnrollment-tab',
      target: '#v-pills-participationsAndEnrollment'
    },
    {
      id: 'v-pills-financials-tab',
      target: '#v-pills-financials'
    },
    {
      id: 'v-pills-programAndProperty-tab',
      target: '#v-pills-programAndProperty'
    },
    {
      id: 'v-pills-ReviewSubmit-tab',
      target: '#v-pills-ReviewSubmit'
    }
  ];

  const getStatusIcons = (status, number) => {
    if (status === APP_LABELS.STATUS_IN_PROGRESS || status === 'INPROGRESS') {
      return (
        <span className="ymca-order">
          <div className="ymca-order-List">
            {`0${number}`}
            <img src={tabDesign} alt="" className="img-fluid ymca-design" />
          </div>
        </span>
      );
    }
    if (
      status === APP_LABELS.STATUS_COMPLETED ||
      status === APP_LABELS.STATUS_SUBMITTED
    ) {
      return (
        <span className="ymca-order ymca-green">
          <div className="ymca-order-List ymca-orderLabel">
            {`0${number}`}
            <img src={tabComponent} alt="" className="img-fluid ymca-design" />
          </div>
        </span>
      );
    }
    return (
      <span className="ymca-order">
        <div className="ymca-order-List">{`0${number}`}</div>
      </span>
    );
  };

  useEffect(() => {
    const navItems = allCampBranchDashboardData?.data?.find(
      yearwise => yearwise.year === sessionStorage.getItem('selectedBatchYear')
    );
    setMenuItems(navItems);
  }, [allCampBranchDashboardData]);

  useEffect(() => {
    if (window.location.pathname === '/overnight-camp-data/reports') {
      if (CampReportsYearData?.data?.length > 0) {
        setMenuItems(CampReportsYearData?.data[0]);
      }
    }
    return () => {
      setIsDataLoading(false);
    };
  }, [CampReportsYearData]);

  return (
    <div
      className="nav flex-column nav-pills ymca-areaCover"
      id="v-pills-tab"
      role="tablist"
      aria-orientation="vertical"
    >
      <button
        className="nav-link ymca-navLink active"
        id="v-pills-Overview-tab"
        data-bs-toggle="pill"
        data-bs-target="#v-pills-Overview"
        type="button"
        role="tab"
        aria-controls="v-pills-Overview"
        aria-selected="true"
        onClick={() => handleSetActive('v-pills-Overview-tab')}
      >
        <span className="ymca-order">
          <img src={tabCheck} alt="" className="img-fluid" />
        </span>
        <span className="ymca-text">Overview</span>
      </button>
      {menuItems?.dashboardDTOs?.map((data, index) => (
        <button
          className="nav-link ymca-navLink"
          id={navbarListIds[index]?.id}
          key={navbarListIds[index]?.id}
          data-bs-toggle="pill"
          data-bs-target={navbarListIds[index]?.target}
          type="button"
          role="tab"
          aria-controls="v-pills-Staff"
          aria-selected="false"
          onClick={() => handleSetActive(navbarListIds[index]?.id)}
        >
          {getStatusIcons(data?.status?.toUpperCase(), data?.sequenceNo)}
          <span className="ymca-text text-break ">{data?.name}</span>
        </button>
      ))}

      <CustomModal
        show={showPopup}
        type="Warning!"
        message="You have some unsaved changes. If you leave before saving, your changes will be lost."
        submitButtonName="Ok"
        onSubmit={handleOk}
        cancelButtonName="Cancel"
        onCancel={handleCancel}
      />
    </div>
  );
};
SidebarNav.propTypes = {
  setIsDataLoading: PropTypes.func.isRequired,

  setActiveTab: PropTypes.objectOf(PropTypes.any).isRequired,
  CampReportsYearData: PropTypes.objectOf(PropTypes.any).isRequired,
  allCampBranchDashboardData: PropTypes.arrayOf(PropTypes.any).isRequired
};
const mapStateToProps = state => ({
  allCampBranchDashboardData:
    OvernightCampBranchDetailsDashboardSelector(state),
  CampReportsYearData: GetBrachYearWiseReportSelector(state),
  DashboardOverviewSelectorData: DashboardOverviewSelector(state)
});
export default connect(mapStateToProps, null)(React.memo(SidebarNav));
